import { createSlice } from "@reduxjs/toolkit";
import {
  addOffer,
  deleteOffer,
  getAllOffers,
  getOfferDetails,
  getOffersList,
  updateOffer,
  updateOfferStatus,
} from "store/actions/offerSlice";
import { updatecashback } from "store/actions/workspaceSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  offers: [],
  offerDetails: {},
  offersList: [],
};

const couponSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOffers.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};
          state.offers = data;

          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllOffers.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updateOfferStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOfferStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.offers = state?.offers?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateOfferStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteOffer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOffer.fulfilled, (state, action) => {
        const { success } = action.payload || {};
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.offers = state.offers.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteOffer.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getOfferDetails.pending, (state) => {
        state.loading = true;
        state.offerDetails = {};
      })
      .addCase(getOfferDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.offerDetails = data;
        }
      })
      .addCase(getOfferDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(addOffer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addOffer.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addOffer.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateOffer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOffer.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateOffer.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getOffersList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOffersList.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.offersList = data || [];
        }
      })
      .addCase(getOffersList.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default couponSlice.reducer;
